import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import validateFormRole from "../../../validtions/forms/role/add";
import httpService from "../../../services/httpServices/httpServices";
import authorizedComponent from "../../../helpers/authorized-component";

function AddRole() {
  const history = useHistory();
  const [message, setMessage] = useState();
  const [permissions, setPermissions] = useState();

  useEffect(() => {
    setAllPermissions();
  }, []);

  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const setAllPermissions = async () => {
    let permissions = await getPermissions();
    setPermissions(generateTagPermissions(permissions));
  };

  const getPermissions = async () => {
    const headersRequest = getHeaderForRequset();
    let permissions;
    try {
      permissions = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/permission",
        headersRequest
      );
    } catch (error) {
      // alert("مشکلی در دریافت دسترسی ها بوجود آمده است.");
      return;
    }

    return permissions.data.data;
  };

  const generateTagPermissions = (permissions) => {
    return permissions.map((permission) => {
      let permissionTag = (
        <div className="col-12 col-sm-6 col-md-4">
          <span className="w-100 justify-content-between d-inline-flex align-items-center py-2 ">
            <span className="small font-weight-bold text-nowrap ">
              {permission.per_persian_name}
            </span>

            <span>
              <label className="adl-switch">
                <input
                  type="checkbox"
                  value={permission.per_id}
                  className="permissions"
                />
                <span className="adl-slider round"></span>
              </label>
            </span>
          </span>
        </div>
      );

      return permissionTag;
    });
  };

  const getFormData = () => {
    const name = document.getElementById("name").value;
    const persianName = document.getElementById("name-persian").value;
    const checkeBoxes = document.querySelectorAll(".permissions:checked");
    let permissions = [];
    checkeBoxes.forEach((checkeBox) => {
      permissions.push(checkeBox.defaultValue);
    });

    return {
      name: name,
      persian_name: persianName,
      permissions: permissions,
    };
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const formData = getFormData();
    if (validateFormRole(formData) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormRole(formData),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }

    const result = await sendRuquest(formData);
    if (result) {
      history.push("/roles/all");
    }
  };

  const sendRuquest = async (formData) => {
    const headersRequest = getHeaderForRequset();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/role",
        formData,
        headersRequest
      );
      history.push("/role/all");
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return true;
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar openItem="role-permission" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">نقش جدید</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <form onSubmit={sendForm}>
                <div className="form-group">
                  <label>نام انگلیسی</label>
                  <input type="text" className="form-control" id="name" />
                </div>
                <div className="form-group">
                  <label>نام فارسی</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name-persian"
                  />
                </div>

                <div className="form-group mb-0">
                  <label>دسترسی ها</label>
                </div>
                <div className="  alert alert-secondary   p-2">
                  <div className="form-group">
                    <div className="container-fluid">
                      <div className="row">{permissions}</div>
                    </div>
                  </div>
                </div>
                <button type="submit" className="btn btn-outline-primary">
                  ارسال
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddRole;
